import { render, staticRenderFns } from "./targetForm.vue?vue&type=template&id=396bf412"
import script from "./targetForm.vue?vue&type=script&lang=js"
export * from "./targetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports